{
  "experienceEyebrow": "THE BLOOM EXPERIENCE",
  "headline": "More Than a Place to Live.",
  "subheadline": "A Bloom Way of Life.",
  "ctaLabel": "Let's Get Started",
  "ctaHref": "/welcome?login=1",
  "exploreTitle": "Explore Bloom World",
  "exploreSubtitle": "Discover the communities, experiences and services that shape everyday life.",
  "spaces": [
    {
      "spaceKey": "landscape",
      "title": "Bloom Landscape",
      "gridSpan": "quarter",
      "sortOrder": 5,
      "isActive": true,
      "pageHeadline": "Bloom Landscape",
      "pageBody": "Bloom Landscape provides end-to-end landscaping services, from design and construction to maintenance, for both local and international clients. With expertise across projects of all scales, Bloom Landscape is recognized for high-quality delivery, customer care, and attention to detail.",
      "pageCtaLabel": "Discover more",
      "pageCards": [
        {
          "cardKey": "landscape-design",
          "title": "Landscape Design"
        },
        {
          "cardKey": "hardscape-construction",
          "title": "Hardscape Construction"
        },
        {
          "cardKey": "nursery",
          "title": "Nursery"
        },
        {
          "cardKey": "softscape-installation",
          "title": "Softscape Installation"
        },
        {
          "cardKey": "irrigation-system",
          "title": "Irrigation System"
        },
        {
          "cardKey": "operations-maintenance",
          "title": "Operations & Maintenance"
        }
      ]
    },
    {
      "spaceKey": "properties",
      "title": "Bloom Properties",
      "gridSpan": "tall",
      "sortOrder": 1,
      "isActive": true,
      "pageHeadline": "Bloom Properties",
      "pageBody": "Bloom properties is the developer of choice for curated premium communities in prime locations, with a proven track record of on-time delivery and a commitment to creating long-term value for end-users and investors.",
      "pageCtaLabel": "Discover more",
      "pageCtaHref": "/guest",
      "pageCards": [
        {
          "cardKey": "park-view",
          "title": "Park View"
        },
        {
          "cardKey": "soho-square",
          "title": "Soho Square"
        },
        {
          "cardKey": "bloom-gardens",
          "title": "Bloom Gardens"
        },
        {
          "cardKey": "al-dhay",
          "title": "Al Dhay"
        },
        {
          "cardKey": "bloom-height",
          "title": "Bloom Height"
        },
        {
          "cardKey": "bloom-tower",
          "title": "Bloom Tower"
        }
      ]
    },
    {
      "spaceKey": "retail",
      "title": "Bloom Retail",
      "gridSpan": "quarter",
      "sortOrder": 3,
      "isActive": true,
      "pageHeadline": "Bloom Retail",
      "pageBody": "Vibrant retail destinations that bring communities together — curated shopping, dining, and everyday conveniences.",
      "pageCtaLabel": "Discover more",
      "pageCards": [
        {
          "cardKey": "retail-1",
          "title": "Neighbourhood Retail"
        },
        {
          "cardKey": "retail-2",
          "title": "Dining Destinations"
        },
        {
          "cardKey": "retail-3",
          "title": "Convenience"
        },
        {
          "cardKey": "retail-4",
          "title": "Coming Soon"
        }
      ]
    },
    {
      "spaceKey": "facilities",
      "title": "Bloom Facilities Management",
      "gridSpan": "half",
      "sortOrder": 6,
      "isActive": true,
      "pageHeadline": "Bloom Facilities Management (BFM)",
      "pageBody": "Bloom properties is the developer of choice for curated premium communities in prime locations, with a proven track record of on-time delivery and a commitment to creating long-term value for end-users and investors.",
      "pageCtaLabel": "Discover more",
      "pageCards": [
        {
          "cardKey": "sustainability-services",
          "title": "Sustainability Services"
        },
        {
          "cardKey": "bloom-home-service",
          "title": "Bloom Home Service"
        },
        {
          "cardKey": "residential-services",
          "title": "Residential Services"
        },
        {
          "cardKey": "corporate-services",
          "title": "Corporate Services"
        }
      ]
    },
    {
      "spaceKey": "hospitality",
      "title": "Bloom Hospitality",
      "gridSpan": "quarter",
      "sortOrder": 4,
      "isActive": true,
      "pageHeadline": "Bloom Hospitality",
      "pageBody": "We own and operate internationally recognized five-star hotels and luxury hotel apartments in association with leading brands including Marriott Hotel Downtown Abu Dhabi, The Abu Dhabi EDITION, and Bloom Arjaan by Rotana. Thoughtfully embedded within our communities, these hotels attract visitors who play a vital role in driving long-term economic value.",
      "pageCtaLabel": "Discover more",
      "pageCards": [
        {
          "cardKey": "marriott-downtown",
          "title": "Marriott Hotel Downtown Abu Dhabi"
        },
        {
          "cardKey": "abu-dhabi-edition",
          "title": "The Abu Dhabi EDITION"
        }
      ]
    },
    {
      "spaceKey": "education",
      "title": "Bloom Education",
      "gridSpan": "quarter",
      "sortOrder": 2,
      "isActive": true,
      "pageHeadline": "Bloom Education",
      "pageBody": "We are a leading education provider, shaping future generations through world-class schools, nurseries, and education partnerships across the UAE.",
      "pageCtaLabel": "Discover more",
      "pageCards": [
        {
          "cardKey": "brighton-colleges",
          "title": "Brighton Colleges",
          "subtitle": "Abu Dhabi, Al Ain, Dubai"
        },
        {
          "cardKey": "charter-schools",
          "title": "Charter Schools",
          "subtitle": "Emirates Schools Establishment"
        },
        {
          "cardKey": "bloom-world-academy",
          "title": "Bloom World Academy"
        },
        {
          "cardKey": "bloom-nurseries",
          "title": "Bloom Nurseries"
        }
      ]
    }
  ]
}
